module.exports = __webpack_public_path__ + "static/media/failed-order.1e880c0b.svg";